import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  getBeneListByMobileNumber: "",
  payrentPennyDrop: "",
  generateOrderAndPaymnetLink: "",
};

const getBeneListByMobileNumberStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getBeneListByMobileNumber: "",
    error: "",
  };
};

const getBeneListByMobileNumberSuccess = (state, data) => {
  return {
    ...state,
    getBeneListByMobileNumber: data,
    isLoading: false,
    error: "",
  };
};

const getBeneListByMobileNumberFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//penny drop
const payrentPennyDropStart = (state) => {
  return {
    ...state,
    isLoading: true,
    payrentPennyDrop: "",
    error: "",
  };
};

const payrentPennyDropSuccess = (state, data) => {
  return {
    ...state,
    payrentPennyDrop: data,
    isLoading: false,
    error: "",
  };
};

const payrentPennyDropFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//generate Order And Paymnet Link
const generateOrderAndPaymnetLinkStart = (state) => {
  return {
    ...state,
    isLoading: true,
    generateOrderAndPaymnetLink: "",
    error: "",
  };
};

const generateOrderAndPaymnetLinkSuccess = (state, data) => {
  return {
    ...state,
    generateOrderAndPaymnetLink: data,
    isLoading: false,
    error: "",
  };
};

const generateOrderAndPaymnetLinkFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const PayrentReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.GET_BENI_LIST_BY_REMITTER_MOBILE_START:
      return getBeneListByMobileNumberStart(state);
    case actionTypes.GET_BENI_LIST_BY_REMITTER_MOBILE_SUCCESS:
      return getBeneListByMobileNumberSuccess(state, action.data);
    case actionTypes.GET_BENI_LIST_BY_REMITTER_MOBILE_FAIL:
      return getBeneListByMobileNumberFail(state, action.err);

    case actionTypes.PAYRENT_PENNY_DROP_START:
      return payrentPennyDropStart(state);
    case actionTypes.PAYRENT_PENNY_DROP_SUCCESS:
      return payrentPennyDropSuccess(state, action.data);
    case actionTypes.PAYRENT_PENNY_DROP_FAIL:
      return payrentPennyDropFail(state, action.err);

    case actionTypes.GENERATE_ORDER_AND_PAYMENT_LINK_START:
      return generateOrderAndPaymnetLinkStart(state);
    case actionTypes.GENERATE_ORDER_AND_PAYMENT_LINK_SUCCESS:
      return generateOrderAndPaymnetLinkSuccess(state, action.data);
    case actionTypes.GENERATE_ORDER_AND_PAYMENT_LINK_FAIL:
      return generateOrderAndPaymnetLinkFail(state, action.err);

    default:
      return state;
  }
};

export default PayrentReducer;
